import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { get as _get } from 'lodash';
import { GoogleDFP, Spinner } from '@surfline/quiver-react';
import ContestCard from '../../../components/ContestCard';
import ContestContainer from '../../../components/ContestContainer';
import ContestAwardCard from '../../../components/ContestAwardCard';
import ContestEntryCard from '../../../components/ContestEntryCard';
import ContestHelmet from '../../../components/ContestHelmet';
import ContestWinnerCard from '../../../components/ContestWinnerCard';
import PromoBoxSlides from '../../../components/PromoBoxSlides';
import {
  clearContestEntries,
  fetchContest,
  fetchContestNews,
  fetchContestEntries,
} from '../../../actions/contests';
import { navigatedToPage, trackEvent } from '../../../actions/segmentEvents';
import contestsPropType from '../../../propTypes/contests';
import contestParamsPropType from '../../../propTypes/contestParams';
import loadAdConfig from '../../../utils/adConfig';
import getContestAdId from '../../../utils/getContestAdId';
import config from '../../../config';
import allContests from './allContests';
import contestAwards from './contestAwards';
import pastWinners from './pastWinners';

class ContestLanding extends Component {
  // eslint-disable-next-line react/sort-comp
  static fetch = [
    (params, { cookies }) => fetchContest(params, cookies),
    (params, { cookies }) => fetchContestNews(params, cookies),
    params => fetchContestEntries(params),
  ];

  componentDidMount() {
    const {
      contests,
      doFetchContest,
      doFetchContestNews,
      doFetchContestEntries,
      doNavigatedToPage,
      match: { params },
    } = this.props;
    if (!contests.contest) doFetchContest(params);
    if (!contests.contestNews.news.length) doFetchContestNews(params);
    if (!contests.contestEntries.entries.length) doFetchContestEntries(params);
    doNavigatedToPage('Contest Landing', {
      contestRegion: params.region,
      category: 'contests',
    });
  }

  componentDidUpdate(prevProps) {
    const {
      contests,
      doFetchContest,
      doFetchContestNews,
      doFetchContestEntries,
      match: { params },
    } = this.props;
    if (prevProps.contests.contest !== contests.contest) {
      doFetchContest(params);
      doFetchContestNews(params);
      doFetchContestEntries(params.region);
    }
    if (prevProps.contests.contestEntries.entries.length
      && !contests.contestEntries.entries.length) {
      doFetchContestEntries(params);
    }
  }

  componentWillUnmount() {
    const { doClearContestEntries } = this.props;
    doClearContestEntries();
  }

  render() {
    const {
      contests: { contest, contestNews, contestEntries },
      doTrackEvent,
      match: { params: { period, region } },
    } = this.props;
    const periodRange = period.split('-');
    // eslint-disable-next-line no-unused-vars
    const [_, currentPeriodYear] = periodRange;
    const periodAwarePastWinners = pastWinners.filter((winner) =>
      winner.year < currentPeriodYear);
    return (
      <ContestContainer contest={contest} period={period} region={region} showLogo={false}>
        <ContestHelmet
          title={_get(contest, 'post.post_title', null)}
          description={_get(contest, 'meta.acf.contest_details', null)}
          period={period}
          region={region}
        />
        <div className="sl-contest-landing">
          <div className="sl-contest-landing__top">
            <div className="sl-contest-landing__top__promobox">
              {contestNews.loading ? <Spinner /> : null}
              {contestNews.news.length
                ? <PromoBoxSlides promoBoxSlides={contestNews.news} doTrackFeed={() => {}} />
                : null}
            </div>
            <div className="sl-contest-landing__top__nav">
              {_get(contest, 'meta.acf.logo', null)
                ? (
                  <div className="sl-contest-landing__top__nav__logo">
                    <img src={contest.meta.acf.logo} alt={contest.name} />
                  </div>
                )
                : null}
              <div className="sl-contest-landing__top__nav__links">
                <Link to={`/${config.baseContestUrl(region, period)}entries`}>View entries</Link>
                <Link to={`/${config.baseContestUrl(region, period)}details`}>Contest Details</Link>
                <Link to={`/${config.baseContestUrl(region, period)}submit`}>Submit a video</Link>
                {contest.meta.acf.vote_url ? <a href={contest.meta.acf.vote_url}>Vote</a> : null}
              </div>
            </div>
          </div>
          <div className="sl-contest-landing__entries__container">
            <div className="sl-contest__ad-unit">
              <GoogleDFP adConfig={loadAdConfig(getContestAdId(region, 'top', period), [['Box', 'Banner']])} />
            </div>
            <h3>Latest Entries</h3>
            <div className="sl-contest-landing__entries">
              {contestEntries.loading ? <Spinner /> : null}
              {contestEntries.entries.length
                ? contestEntries.entries.map(entry => (
                  <ContestEntryCard
                    entry={entry}
                    doTrackEvent={doTrackEvent}
                    period={period}
                    region={region}
                    key={entry.id}
                  />
                ))
                : null}
              {(!contestEntries.entries.length && !contestEntries.loading)
                ? (
                  <p className="sl-contest-landing__no-entries">No entries yet. Be the first to
                    <Link to={`/${config.baseContestUrl(region, period)}submit`}> Submit</Link>
                  </p>
                )
                : null}
            </div>
            {contestEntries.entries.length
              ? (
                <Link
                  className="sl-contest-landing__entries__button"
                  to={`/${config.baseContestUrl(region, period)}entries`}
                >
                View all entries
                </Link>
              )
              : null}
          </div>
          {region === 'north-shore'
            ? (
              <div className="sl-contest-winners__container">
                <h3>Previous Winners</h3>
                <div className="sl-contest-winners">
                  {periodAwarePastWinners.length
                    ? periodAwarePastWinners.map(winner => <ContestWinnerCard winner={winner} key={winner.year} />)
                    : null}
                </div>
              </div>
            )
            : null}
          <div className="sl-contest__ad-unit">
            <GoogleDFP adConfig={loadAdConfig(getContestAdId(region, 'mid', period), [['Box', 'Banner']])} />
          </div>
          <div className="sl-contest-awards__container">
            <h3>{region === 'north-shore' ? 'Special Awards' : 'Contest Details'}</h3>
            <div className="sl-contest-awards">
              {contestAwards[period] && contestAwards[period][region]
                ? contestAwards[period][region].map(award =>
                  <ContestAwardCard award={award} key={award.title} />)
                : null}
            </div>
          </div>
          <div className="sl-contest-contests__container">
            <h3>Wave of the Winter: Regional Edition</h3>
            <p>
              {`Welcome to a new Wave of the Winter for the people, created to celebrate
                  unsung local heroes who charge at beaches around the country, all winter long.
                  Surfline’s inaugural Regional O’Neill Wave of the Winter contests will be judged
                  via online user voting after the four-month holding period. (December 1, 2019
                  to March 31, 2020.) `}
            </p>
            <div className="sl-contest-contests">
              {region !== 'north-shore'
                ? <ContestCard contest={allContests[period]['north-shore']} large /> : null}
              <div className="sl-contest-contests__list">
                {allContests[period].regional.map(contestRegion =>
                  <ContestCard contest={contestRegion} key={contest.name} />)}
              </div>
            </div>
          </div>
          <div className="sl-contest__ad-unit">
            <GoogleDFP adConfig={loadAdConfig(getContestAdId(region, 'bottom', period), [['Box', 'Banner']])} />
          </div>
        </div>
      </ContestContainer>
    );
  }
}

ContestLanding.propTypes = {
  contests: contestsPropType.isRequired,
  doClearContestEntries: PropTypes.func.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  doFetchContest: PropTypes.func.isRequired,
  doFetchContestNews: PropTypes.func.isRequired,
  doFetchContestEntries: PropTypes.func.isRequired,
  doNavigatedToPage: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: contestParamsPropType,
  }).isRequired,
};

export default connect(
  state => ({
    contests: state.contests,
  }),
  dispatch => ({
    doClearContestEntries: () => dispatch(clearContestEntries()),
    doTrackEvent: (name, properties) => dispatch(trackEvent(name, properties)),
    doFetchContest: params => dispatch(fetchContest(params)),
    doFetchContestNews: params => dispatch(fetchContestNews(params)),
    doFetchContestEntries: params => dispatch(fetchContestEntries(params)),
    doNavigatedToPage: (name, properties) => dispatch(navigatedToPage(name, properties)),
  }),
)(ContestLanding);
